import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export const PAGE_SIZE = 100;

// Paginação no servidor: a tela pede só a página atual e usa o total (X-Total-Count) para montar os controles.
export default function Pagination({ page, total, onChange, pageSize = PAGE_SIZE, disabled = false }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (!total || totalPages <= 1) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const btn = 'p-1.5 rounded border border-slate-200 disabled:opacity-40 hover:bg-slate-50 transition-colors';
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 px-5 py-3 border-t border-slate-100" data-testid="pagination">
      <span className="text-xs text-slate-500">Mostrando {from}–{to} de {total}</span>
      <div className="flex items-center gap-2">
        <button disabled={disabled || page <= 1} onClick={() => onChange(1)} className={btn} title="Primeira página" data-testid="pagination-first">
          <ChevronsLeft className="w-4 h-4" />
        </button>
        <button disabled={disabled || page <= 1} onClick={() => onChange(page - 1)} className={btn} title="Página anterior" data-testid="pagination-prev">
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="text-xs font-medium text-slate-600 px-2 tabular-nums" data-testid="pagination-label">Página {page} de {totalPages}</span>
        <button disabled={disabled || page >= totalPages} onClick={() => onChange(page + 1)} className={btn} title="Próxima página" data-testid="pagination-next">
          <ChevronRight className="w-4 h-4" />
        </button>
        <button disabled={disabled || page >= totalPages} onClick={() => onChange(totalPages)} className={btn} title="Última página" data-testid="pagination-last">
          <ChevronsRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
